import React, { useEffect, useState } from 'react'
import { Pagination, Popconfirm, Table } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDebounce } from 'use-debounce'
import Notifications from '../../../helpers/Notifications'
import { reMessageToAdminTypesActions } from './store/actions'
import CustomButton from '../../../components/CustomButton'
import CustomInput from '../../../components/CustomInput'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AddIcon from '../../../components/Icons/add.svg'
import AuditIcon from '../../../components/Icons/audit.svg'
import ReMessageToAdminTypeChangeForm from "./change"
import LocalLoading from '../../../components/Loading/Local'
import ModalAudit from '../ModalAudit'
import { useTranslation } from "react-i18next"
import dayjs from "dayjs"
import api from "./store/api"

const ReMessageToAdminType = (props) => {
	const { isModify = false } = props
	const pageSize = 10
	const [visible, setVisible] = useState(false)
	const [visibleAudit, setVisibleAudit] = useState(false)
	const [record, setRecord] = useState(null)
	const [idRecordAudit, setIdRecordAudit] = useState(null)
	const [count, setCount] = useState(0)
	const [table, setTable] = useState([])
	const [page, setPage] = useState(1)
	const [search, setSearch] = useState(null)
	const [searchValue] = useDebounce(search, 500)
	const { isSending, changed, paged } = useSelector((state) => state.reMessageToAdminTypeReducer)
	const {t} = useTranslation(['common', 'valid', 'action'])
	const dispatch = useDispatch()

	const getPaged = params => {
		dispatch(reMessageToAdminTypesActions.getPaged(params))
	}
	const getPagedAll = params => {
		dispatch(reMessageToAdminTypesActions.getPagedAll(params))
	}
	const create = params => {
		dispatch(reMessageToAdminTypesActions.create(params))
	}
	const remove = params => {
		dispatch(reMessageToAdminTypesActions.remove(params))
	}
	const update = params => {
		dispatch(reMessageToAdminTypesActions.update(params))
	}
	const restore = params => {
		dispatch(reMessageToAdminTypesActions.restore(params))
	}

	useEffect(() => {
		return () => {
			dispatch(reMessageToAdminTypesActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
		}
	}, [changed])

	useEffect(() => {
		onPaginationChange(1)
	}, [searchValue])

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	function onPaginationChange(value){
		setPage(value)
		const params = {
			name     : searchValue?.trim(),
			pageSize : pageSize,
			page     : value
		}
		if (isModify)
			getPagedAll(params)
		else
			getPaged(params)
	}

	const comColumns = [
		{
			title     : t('common:code'),
			dataIndex : 'code',
			key       : 'code'
		},
		{
			title     : t('common:title'),
			dataIndex : 'name',
			key       : 'name'
		}
	]

	const manageColumns = [
		...comColumns,
		{
			title       : t("common:dateCreate"),
			dataIndex   : "createDate",
			key         : "createDate",
			width       : "10%",
			render      : (date) => dayjs(date).format("DD.MM.YYYY"),
		},
		{
			dataIndex : "id",
			key       : 'id',
			width     : 100,
			render    : (id, record) => (
				<div className="changeIcon">
					<img alt=""
						src={UpdateIcon}
						title={t('edit')}
						onClick={() => {
							setVisible(true)
							setRecord(record)
						}}
					/>
					<Popconfirm
						cancelText={t('no')}
						okText={t('yes')}
						placement="left"
						title={!record.isDeleted ? t('valid:sureToDelete') : t('valid:sureToRestore')}
						onCancel={(e) => {
							e.stopPropagation()
							return null
						}}
						onConfirm={(e) => {
							e.stopPropagation()
							!record.isDeleted ? remove({ id }) : restore({ id })
						}}
					>
						<img alt=""
							src={!record.isDeleted ? DeleteIcon : RestoreIcon}
							title={!record.isDeleted ? t('action:delete') : t('action:restore')}
						/>
					</Popconfirm>
					<img alt=""
						className="audit-icon-svg"
						src={AuditIcon}
						title={t('common:historyOfChange')}
						onClick={() => {
							setVisibleAudit(true)
							setIdRecordAudit(id)
						}}
					/>
				</div>
			)
		}
	]
	
	return (
		<>
			<div className="header-admin-nsi">
				<CustomInput
					maxLength={64}
					placeholder={t('action:enterNameCode')}
					onChange={(e) => setSearch(e.target.value)}
				/>
				{isModify
					? (
						<CustomButton
							className="add-nsi"
							type="green"
							onClick={() => {
								setRecord(null)
								setVisible(true)
							}}
						>
							<div>
								<img alt="" src={AddIcon}/>
								<span>{t('action:add')}</span>
							</div>
						</CustomButton>
					)
					: null
				}
			</div>
			<Table
				columns={isModify ? manageColumns : comColumns}
				dataSource={table?.map((el, idx) => ({key: el.code, ...el}))}
				loading={{indicator: <LocalLoading/>, spinning: isSending}}
				pagination={false}
				scroll={{x: 1100}}
			/>
			{
				count > pageSize &&
				<Pagination
					showQuickJumper
					current={page}
					pageSize={pageSize}
					showSizeChanger={false}
					size="small"
					total={count}
					onChange={onPaginationChange}
				/>
			}
			{isModify &&
				<ReMessageToAdminTypeChangeForm
					create={create}
					record={record}
					setRecord={setRecord}
					setVisible={setVisible}
					update={update}
					visible={visible}
				/>
			}
			<ModalAudit
				columns={comColumns}
				setIdRecordAudit={setIdRecordAudit}
				idRecordAudit={idRecordAudit}
				setVisible={setVisibleAudit}
				visible={visibleAudit}
				pageSize={pageSize}
				func={api.getPagedAudit}
			/>
		</>
	)
}

export default ReMessageToAdminType